var map = {
	"./advanceV2/routes.js": "c0yq",
	"./bLogin/routes.js": "sP6e",
	"./cash/routes.js": "9/Kj",
	"./dailyPay/routes.js": "mkNW",
	"./my/routes.js": "DFhL",
	"./test/routes.js": "bno9",
	"./wageSlip/routes.js": "fIao"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WIx8";